<div
  *ngIf="optionSelected()"
  class="flex h-full w-fit cursor-pointer select-none items-center justify-center px-2 pt-1 text-white"
  (click)="onButtonClicked()"
>
  <p class="mb-0.5 font-sans text-inherit">{{ optionSelected()?.label }}</p>
</div>
